import { pluginId, referralId } from "@/assets/googleTrackIds";
import { Carousel, LegacyCard } from "@payping/web-components";
import { Link } from "react-router-dom";
import { DashboardRoutes } from "@/router";
import { URLS } from "@payping/utilities-shared/consts";

const CarouselBanner = () => (
  <LegacyCard.Ant classNames={{ body: "tw:p-0!" }} size="small" className="tw:relative tw:w-full">
    {/* @ts-ignore add ( draggable ) type to Carousel Component */}
    <Carousel dots={false} autoplay draggable={true} className="tw:w-full">
      <div className="tw:h-[150px]" data-google-track={pluginId}>
        <Link to={DashboardRoutes.connections.plugins.root.url}>
          <img
            src={`${URLS.STORAGE_URL}/img/home/slideBannerPluginPardakht.png`}
            className="tw:h-full tw:w-full tw:object-contain"
            alt="Banner Plugin Pardakht"
          />
        </Link>
      </div>
      <div className="tw:h-[150px] tw:object-contain" data-google-track={referralId}>
        <Link to={DashboardRoutes.user.referral.url}>
          <img
            src={`${URLS.STORAGE_URL}/img/home/slideBannerKasbDaramad.png`}
            className="tw:h-full tw:w-full tw:object-contain"
            alt="Banner Kasb Daramad"
          />
        </Link>
      </div>
      <div className="tw:h-[150px] tw:object-contain" data-google-track={referralId}>
        <a
          target="_blank"
          href={`https://installment.${process.env.REACT_APP_DOMAIN}/?utm_source=Dashboard&utm_medium=Banner&utm_campaign=Lead-Generation&utm_id=Dashboard1`}
          rel="noreferrer"
        >
          <img
            src={`${URLS.STORAGE_URL}/img/home/home-slider-bnpl-slider.jpg`}
            className="tw:h-full tw:w-full tw:object-contain"
            alt="Installment payment"
          />
        </a>
      </div>
    </Carousel>
  </LegacyCard.Ant>
);

export default CarouselBanner;
